@if (isExpert && stream.name == TechnicianStreamName) {
  <div id="{{ stream.name }}" ngClass="{{ stream.hasVideo ? 'video' : 'audio '}}" [ngStyle]="{ 'opacity': opacity }" #subscriberDiv></div>
}
@if (!isExpert && stream.name == ExpertStreamName) {
  <div id="{{ stream.name }}" class="audio" [ngStyle]="{ 'opacity': opacity }" #subscriberDiv></div>
}
@if (stream.videoType == 'screen') {
  <div class="screenshare" #subscriberDiv> </div>
}
@if (stream.name.includes('AUDIO_CONNECTOR')) {
  <div class="audioTranslate" #subscriberDiv> </div>
}
